

















































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
import { date } from 'quasar';
import formatDate = date.formatDate;
import getDateDiff = date.getDateDiff;
import { Action, Getter, Mutation, State } from 'vuex-class';
import { CartState } from '@/store/cart/types';
import { IFile } from '@resclick/data-access';

@Component
export default class Cart extends Vue {
  @State('cart') cart!: CartState;
  @Getter('cart/total') cartTotal!: { value: number; currency: string };
  @Action('cart/removeFromCart') removeFromCart!: any;
  @Mutation('cart/setPromotionCode') setPromotionCode!: any;

  formatDate = formatDate;
  getDateDiff = getDateDiff;

  flightsShowDetails = false;

  get rooms() {
    return this.cart.products.filter((product) => product.productCategory === 'PROPERTY');
  }

  get flights() {
    return this.cart.products.filter((product) => product.productCategory === 'FLIGHT')[0];
  }

  get flightRoutesLength() {
    if (!this.flights) return 0;
    const flights = this.flights as any;
    const outboundRoutes = flights?.outboundFlight?.routes?.length || 0;
    const returnRoutes = flights?.outboundFlight?.routes?.length || 0;

    return outboundRoutes > returnRoutes ? outboundRoutes : returnRoutes;
  }

  calculateAge(birthday: string) {
    const birth = new Date(birthday);
    const ageDifMs = Date.now() - birth.getTime();
    const ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

  thumbImage(image: IFile) {
    if (image?.sizes?.small) {
      return process.env.VUE_APP_CDN_URL + '/' + image.sizes.thumbnail;
    }
    return '';
  }
}
